import React from "react";
import centerLineImg from "../images/center-line.png";

import divicesImg from "../images/divices.png";
import DemoContent from "./demo-content/DemoContent";

function DemoSection() {
  return (
    <section id="demo" className="relative">
      <div className="mx-auto ">
        <div className="flex flex-row justify-center mb-20 relative ">
          <img
            className="w-full absolute top-44"
            src={centerLineImg}
            alt="center-line"
          />
          <div className="pb-12 md:pb-16 wrapper">
            <DemoContent />
          </div>
          <div className=" w-full relative flex mr-6 wrapper-demo">
            <img src={divicesImg} alt="divices-bg " className="demo-image" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default DemoSection;
